import { TFunction } from 'i18next';
import { GenericResponse } from 'src/js/model/api/response/generic-response';

export interface ComPortViewModel {
  baudRate: number;
  dataBits: number;
  flowControl: number;
  mode: number;
  parity: number;
  passthroughActive: boolean;
  standard: number;
  stopBits: number;
}

export enum ComPortMode {
  MANAGEMENT = 0,
  METDATA = 1,
  PASSTHROUGH = 2,
}

export interface ComPortResponse extends GenericResponse {}

export const baudRateOptions = [1200, 2400, 4800, 9600, 19200, 38400, 57600, 115200].map((v) => ({
  value: v,
  label: v.toString(),
}));

export const getStandardString = (standard: number, t: TFunction) => {
  switch (standard) {
    case 0:
      return 'RS-232';
    case 1:
      return 'RS-422';
    default:
      return t('general.unknown');
  }
};

export const getParityString = (parity: number, t: TFunction) => {
  switch (parity) {
    case 0:
      return t('general.none');
    default:
      return t('general.unknown');
  }
};

export const getStopBitsString = (stopBits: number, t: TFunction) => {
  switch (stopBits) {
    case 0:
    case 1:
      return '1';
    default:
      return t('general.unknown');
  }
};

export const getFlowControlString = (flowControl: number, t: TFunction) => {
  switch (flowControl) {
    case 0:
      return t('general.none');
    default:
      return t('general.unknown');
  }
};
